import RESTAPIConfig from "@/config/RESTAPIConfig";
import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {AxiosError} from "axios";
import {showPopup} from "@/features/PopupMessages/PopupMessages";
import {JsonResponseInterface} from "@/common/Http/Interfaces/JsonResponseInterface";
import {
    CategoriesResponseInterface
} from "@/features/InControlPanel/KnowledgeBase/CategoriesTree/Interfaces/CategoriesResponseInterface";
import i18n from "@/i18n/i18n";
import configuredStore from "@/store/Store";
import {getAccessToken, userLangHeaderName} from "@/store/ApiSlice";

const restApiConfig = new RESTAPIConfig();

export const getThreeThunk = createAsyncThunk(
    "categories/getThree",
    async () => {
        const inTrash = configuredStore.getState().inCPKnowledgeBaseCategoriesTree.showCategoriesInTrash;
        const inTrashParam = inTrash ? "?inTrash=1" : "";

        const url = restApiConfig.baseUrl + restApiConfig.apiPrefix + restApiConfig.getKnowledgeBaseCategoriesTree() + inTrashParam;
        const userLang = configuredStore.getState().lang.userLang;
        const token = getAccessToken(configuredStore.getState());
        try {
            const response = await axios.get<JsonResponseInterface<CategoriesResponseInterface>>(url, {
                headers: {
                    "Content-Type": "application/json;charset=utf-8",
                    [userLangHeaderName]: userLang,
                    "Authorization": `Bearer ${token}`,
                }
            });

            return response.data;
        } catch (e: unknown) {
            const error = e as AxiosError;
            //@ts-ignore
            const message = i18n.t("Error with code and text", {code: error.response.status, error: error.response.data.errors.toString()});
            showPopup({
                type: "error",
                message,
                autoClose: 5000,
            });
        }
    }
);